import React from 'react';
import { companyInfo } from '../mock';
import Reveal from './Reveal';
import ContactInfo from './ContactInfo';
import ContactCards from './ContactCards';

const Contact = () => {
  const whatsappHref = `https://wa.me/${companyInfo.whatsapp}?text=${encodeURIComponent(
    "Hi Cherry Stone, I'd like to enquire about"
  )}`;
  const mailHref = `mailto:${companyInfo.email}?subject=${encodeURIComponent(
    'Cherry Stone \u2014 Project Enquiry'
  )}`;

  return (
    <section id="contact" className="relative py-24 md:py-36 bg-[#F1EBE1]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-14">
          <div className="lg:col-span-5">
            <Reveal>
              <span className="section-num text-sm">06 &mdash; Contact</span>
              <h2 className="mt-4 font-serif text-4xl md:text-5xl leading-[1.05] text-[#1a1a1a]">
                Let&rsquo;s build something
                <br />
                <span className="italic">enduring</span>.
              </h2>
              <p className="mt-6 text-[#4a463f] text-[15px] leading-relaxed max-w-md">
                Bring your plans, mood boards or a rough sketch &mdash; we&rsquo;ll help you
                find the right stone and craft it to fit.
              </p>
            </Reveal>

            <ContactInfo />
          </div>

          <Reveal className="lg:col-span-7" delay={100}>
            <ContactCards whatsappHref={whatsappHref} mailHref={mailHref} />
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Contact;
